// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radiocommunication-priority-rules.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radiocommunication-priority-rules/radiocommunication-priority-rules.js';

mount([g0]);
